import { TableHeader } from '@/components/ui/table';

export function AvgPcsTagHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      Average
      <br />
      PCS TAG
    </TableHeader>
  );
}
